import { render } from "./Infant.vue?vue&type=template&id=c2733a32&scoped=true"
import script from "./Infant.vue?vue&type=script&lang=js"
export * from "./Infant.vue?vue&type=script&lang=js"

import "./Infant.vue?vue&type=style&index=0&id=c2733a32&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2733a32"]])

export default __exports__